<!--
  ■■■■■■■プロフィール表示画面■■■■■■■
-->
<!--
  コンポーネント呼び出し
  ＊profile - ポップアップを出すトリガー
  ＊profuid - プロフィールのuid
  <profile_display 
        :profile="profile"
        :profuid="uid" 
        device="pc"
        @closeProfile="closeProfile"/>

  追加関数
  closeProfile(){
      this.profile = false
  },
-->

<template>
  <div>
    <v-dialog
      v-if="ispc"
      v-model="trig"
      height="90vh"
      width="700px"
      persistent
      @keydown.esc="trig = false"
    >
      <v-tabs
        vertical
        hide-slider
        dark
        color="#FFFFFF"
        background-color="#294a66"
        style="height: 90vh"
      >
        <!--タイトル-->
        <v-tab class="mt-4 profile-title-pc" disabled>プロフィール </v-tab>
        <v-tab-item><!--ここに書いても意味ないよ--></v-tab-item>

        <!--基本情報-->
        <v-tab class="mt-8 font-weight-bold" color="#FFFFFF">
          基本情報
        </v-tab>
        <v-tab-item class="ptab-item">
          <basicinfo :profuid="profuid" :device="device" @closeProfile="trig = false"/>
        </v-tab-item>

        <!--参加中のLid・プロジェクト-->
        <v-tab
          class="font-weight-bold"
          color="#FFFFFF "
          style="text-transform: none"
        >
          参加中の{{ $t('Lid') }}<span v-if="false">・{{ $t("プロジェクト") }}</span>
        </v-tab>
        <v-tab-item class="ptab-item">
          <prf_mylidandprj :profuid="profuid" :device="device" @closeProfile="$emit('closeProfile')"/>
        </v-tab-item>

        <!--アクティビティログ-->
        <v-tab class="font-weight-bold"> アクティビティログ </v-tab>
        <v-tab-item class="ptab-item">
          <activity_display :profuid="profuid" :device="device" @closeProfile="$emit('closeProfile')"/>
        </v-tab-item>

        <!--アクティビティアマウント-->
        <v-tab class="font-weight-bold" style="text-transform: none">
          アクティビティアマウント
        </v-tab>
        <v-tab-item class="ptab-item">
          <activity_amount :profuid="profuid" :device="device" @closeProfile="$emit('closeProfile')"/>
        </v-tab-item>

        <!--アイデアの位置情報-->
        <v-tab class="font-weight-bold" style="text-transform: none">
          {{ $t("アイデア") }}の位置情報
        </v-tab>
        <v-tab-item class="ptab-item">
          <prf_ideamap :profuid="profuid" :device="device" @closeProfile="$emit('closeProfile')"/>
        </v-tab-item>

        <!--メダルの獲得履歴-->
        <v-tab class="font-weight-bold" style="text-transform: none">
          メダルの獲得履歴
        </v-tab>
        <v-tab-item class="ptab-item">
          <medal_display :profuid="profuid" :device="device" @closeProfile="$emit('closeProfile')"/>
        </v-tab-item>

        <!--作成したプロジェクト-->
        <v-tab class="font-weight-bold" style="text-transform: none">
          作成した{{ $t("プロジェクト") }}
        </v-tab>
        <v-tab-item class="ptab-item">
          <disp_createprj :profuid="profuid" :device="device" @closeProfile="$emit('closeProfile')"/>
        </v-tab-item>
      </v-tabs>
    </v-dialog>

    <v-dialog v-else-if="issp" v-model="trig" persistent fullscreen @keydown.esc="dialog = false">
      <v-card height="100vh" style="background-color:white">
        <v-card-actions class="abyss d-flex align-center pa-2">
          <h2 class="white--text">プロフィール</h2>
          <v-icon @click="trig = false" x-large class="ml-auto" color="white">mdi-close</v-icon>
        </v-card-actions>
        <v-tabs
          dark center-active grow
          background-color="#294a66"
          class="overflow-y-hidden"
          style="height:90vh;"
        >
          <!--基本情報-->
          <v-tab class="font-weight-bold" color="#FFFFFF">
            基本情報
          </v-tab>
          <v-tab-item class="ptab-item-sp">
            <basicinfo :profuid="profuid" :device="device" />
          </v-tab-item>

          <!--参加中のLid・プロジェクト-->
          <v-tab class="font-weight-bold" color="#FFFFFF ">
            参加中の{{ $t('Lid') }}・{{ $t("プロジェクト") }}
          </v-tab>
          <v-tab-item class="ptab-item-sp">
            <prf_mylidandprj :profuid="profuid" :device="device" />
          </v-tab-item>

          <!--アクティビティログ-->
          <v-tab class="font-weight-bold"> アクティビティログ </v-tab>
          <v-tab-item class="ptab-item-sp">
            <activity_display :profuid="profuid" :device="device" />
          </v-tab-item>

          <!--アクティビティアマウント-->
          <v-tab class="font-weight-bold" style="text-transform: none">
            アクティビティアマウント
          </v-tab>
          <v-tab-item class="ptab-item-sp">
            <activity_amount :profuid="profuid" :device="device" />
          </v-tab-item>

          <!--アイデアの位置情報-->
          <v-tab class="font-weight-bold" style="text-transform: none">
            {{ $t("アイデア") }}の位置情報
          </v-tab>
          <v-tab-item class="ptab-item-sp">
            <prf_ideamap :profuid="profuid" :device="device" />
          </v-tab-item>

          <!--メダルの獲得履歴-->
          <v-tab class="font-weight-bold" style="text-transform: none">
            メダルの獲得履歴
          </v-tab>
          <v-tab-item class="ptab-item-sp">
            <medal_display :profuid="profuid" :device="device" />
          </v-tab-item>

          <!--作成したプロジェクト-->
          <v-tab class="font-weight-bold" style="text-transform: none">
            作成した{{ $t("プロジェクト") }}
          </v-tab>
          <v-tab-item class="ptab-item-sp">
            <disp_createprj :profuid="profuid" :device="device" />
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import basicinfo from "./children/basicinfo.vue";
import activity_display from "./children/activity_display.vue";
import medal_display from "./children/medal_display.vue";
import activity_amount from "./children/activity_amount.vue";
import prf_ideamap from "./children/prf_ideamap.vue";
import prf_mylidandprj from "./children/prf_mylidandprj.vue";
import disp_createprj from "./children/disp_createprj.vue";
export default {
  name: "profile_display",
  props: ["profile", "profuid", "device"],
  data() {
    return {
    };
  },
  components: {
    basicinfo,
    activity_display,
    medal_display,
    activity_amount,
    prf_ideamap,
    prf_mylidandprj,
    disp_createprj,
  },
  computed: {
    uid() {
      return this.profuid;
    },
    trig: {
      get() {
        return this.profile;
      },
      set() {
        this.$emit("closeProfile");
      },
    },
    ispc() {
      return this.device == "pc" ? true : false;
    },
    issp() {
      return this.device == "sp" ? true : false;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 959px) {
  .ptab-item-sp {
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 100%;
  }
    .profile-title-pc {
    color: #ffffff !important;
    opacity: 1 !important;
    font-size: x-large;
  }
}
@media screen and (min-width: 960px) {
  .profile-title-pc {
    color: #ffffff !important;
    opacity: 1 !important;
    font-size: x-large;
  }
}

* {
  font-family: mplus-2c-medium !important;
}
</style>